import { createPasswordPolicy, PasswordPolicy } from '@acme/b2b/security';
import { PasswordRequirementsValidationErrors, passwordValidatorFactory } from '@acme/b2b/validators';
import { input } from '@b2b/types/core';
import angular from 'angular';

class PasswordRequirementsController {
  static $inject = ['$element'];

  password = input.required('');
  passwordPolicy = input.required(createPasswordPolicy());

  validationErrors: PasswordRequirementsValidationErrors | null = null;
  requirements = this.createPasswordRequirements(this.passwordPolicy);

  isValidMapper = (key: keyof PasswordRequirementsValidationErrors) => {
    if (this.password == null || this.password === '') {
      return false;
    }

    if (this.validationErrors == null) {
      return true;
    }

    return !this.validationErrors?.[key];
  };

  constructor(private $element: JQuery) {}

  $onInit() {
    this.$element.addClass('acme-password-requirements');
  }

  $onChanges(changes) {
    if (changes.password) {
      const passwordValidator = passwordValidatorFactory(this.passwordPolicy);
      this.validationErrors = passwordValidator(this.password);
    }

    if (changes.passwordPolicy) {
      this.requirements = this.createPasswordRequirements(this.passwordPolicy);
    }
  }

  createPasswordRequirements(passwordPolicy: PasswordPolicy) {
    const requirements: { key: string; label: string }[] = [];

    if (passwordPolicy.passwordMinimumLength > 0) {
      requirements.push({
        key: 'minlength',
        label: `Be a minimum of ${passwordPolicy.passwordMinimumLength} characters`,
      });
    }

    if (passwordPolicy.passwordUseMixedCase) {
      requirements.push({
        key: 'atLeastOneLowercaseLetter',
        label: `Include at least 1 lowercase letter (a through z)`,
      });
      requirements.push({
        key: 'atLeastOneUppercaseLetter',
        label: `Include at least 1 uppercase letter (A through Z)`,
      });
    }

    if (passwordPolicy.passwordMinimumDigits > 0) {
      requirements.push({
        key: 'atLeastOneDigit',
        label: `Include at least ${passwordPolicy.passwordMinimumDigits} digit (0 through 9)`,
      });
    }

    if (passwordPolicy.passwordMinimumSymbols > 0) {
      requirements.push({
        key: 'atLeastOneNonAlphabeticCharacter',
        label: `Include at least ${passwordPolicy.passwordMinimumSymbols} non-alphabetic characters (for example !, $, #, %)`,
      });
    }

    return requirements;
  }
}

export const PasswordRequirementsComponentModule = angular
  .module('acme.common.component.passwordRequirements', [])
  .component('acmePasswordRequirements', {
    templateUrl: 'common/components/password-requirements/password-requirements.component.tpl.html',
    controller: PasswordRequirementsController,
    transclude: true,
    bindings: {
      password: '<',
      passwordPolicy: '<',
    },
  }).name;
